import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import {
  patchCollectionPointsPayload,
  PatchCollectionPointsPayloadResponse,
} from '@/services/data-sources/patch-collection-points-payload';

interface PatchPointsVariables {
  collectionId: string;
  externalId: string;
  payload: Record<string, unknown>;
}

type Options = Omit<
  UseMutationOptions<
    PatchCollectionPointsPayloadResponse,
    Error,
    PatchPointsVariables
  >,
  'mutationFn'
>;

export const usePatchCollectionPointsPayload = (options?: Options) => {
  return useMutation<
    PatchCollectionPointsPayloadResponse,
    Error,
    PatchPointsVariables
  >({
    mutationFn: async (vars) => {
      const response = await patchCollectionPointsPayload(vars);
      if (response?.detail) {
        throw new Error(response.detail);
      }
      return response;
    },
    ...options,
  });
};
